import React, { useEffect, useState } from "react";
import styles from "../styles/office/OfficeDashboard.module.css";
import OfficeTable from "../components/OfficeDashboardPage/OfficeTable";
import OfficeHeader from "../components/OfficeDashboardPage/OfficeHeader";
const OfficeDashboard = () => {
  return (
    <div className={styles.dashboard}>

      <OfficeHeader />
      <OfficeTable />
    </div>
  );
};

export default OfficeDashboard;
